import { createElement, prepend, isNullOrUndefined, getValue, getDefaultDateObject, cldrData } from '@syncfusion/ej2-base';
import { getDateInMs, addDays, resetTime, WEEK_LENGTH } from '../base/util';
import * as cls from '../base/css-constant';
/**
 * view base
 */
var ViewBase = /** @class */ (function () {
    /**
     * Constructor
     */
    function ViewBase(parent) {
        var _this = this;
        this.customHelper = {
            getDayName: function (dt) {
                return _this.parent.getDayNames('abbreviated')[dt.getDay()];
            },
            getDate: function (dt) {
                return _this.parent.globalize.formatDate(dt, { format: 'd' });
            },
            getTime: function (dt) {
                if (_this.parent.isAdaptive) {
                    return _this.parent.globalize.formatDate(dt, { skeleton: 'h' });
                }
                return _this.parent.globalize.formatDate(dt, { skeleton: 'hm' });
            }
        };
        this.parent = parent;
        this.l10n = this.parent.localeObj;
    }
    ViewBase.prototype.createTableLayout = function (className) {
        var clsName = className || '';
        var table = createElement('table', { className: cls.SCHEDULE_TABLE_CLASS + ' ' + clsName });
        var tbody = createElement('tbody');
        table.appendChild(tbody);
        return table;
    };
    ViewBase.prototype.renderPanel = function (type) {
        if (type === cls.PREVIOUS_PANEL_CLASS) {
            prepend([this.element], this.parent.element.querySelector('.' + cls.TABLE_CONTAINER_CLASS));
        }
        else {
            this.parent.element.querySelector('.' + cls.TABLE_CONTAINER_CLASS).appendChild(this.element);
        }
    };
    ViewBase.prototype.setPanel = function (panel) {
        this.element = panel;
    };
    ViewBase.prototype.getPanel = function () {
        return this.element;
    };
    ViewBase.prototype.adjustEventWrapper = function () {
        // Here adjust the events wrapper width based in work cells
    };
    ViewBase.prototype.startDate = function () {
        return this.renderDates[0];
    };
    ViewBase.prototype.endDate = function () {
        return addDays(this.renderDates[this.renderDates.length - 1], 1);
    };
    ViewBase.prototype.getStartHour = function () {
        var startHour = this.parent.globalize.parseDate(this.parent.activeViewOptions.startHour, { skeleton: 'Hm' });
        if (isNullOrUndefined(startHour)) {
            startHour = new Date(2000, 0, 0, 0);
        }
        return startHour;
    };
    ViewBase.prototype.getEndHour = function () {
        var endHour = this.parent.globalize.parseDate(this.parent.activeViewOptions.endHour, { skeleton: 'Hm' });
        if (isNullOrUndefined(endHour)) {
            endHour = new Date(2000, 0, 0, 0);
        }
        return endHour;
    };
    ViewBase.prototype.isCurrentDate = function (date) {
        return date.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0);
    };
    ViewBase.prototype.isCurrentMonth = function (date) {
        return date.getFullYear() === new Date().getFullYear() && date.getMonth() === new Date().getMonth();
    };
    ViewBase.prototype.isWorkDay = function (date) {
        if (this.parent.activeViewOptions.workDays.indexOf(date.getDay()) >= 0) {
            return true;
        }
        return false;
    };
    ViewBase.prototype.isWorkHour = function (date) {
        var startHour = this.parent.globalize.parseDate(this.parent.workHours.start, { skeleton: 'Hm' });
        var endHour = this.parent.globalize.parseDate(this.parent.workHours.end, { skeleton: 'Hm' });
        if (isNullOrUndefined(startHour) || isNullOrUndefined(endHour)) {
            return false;
        }
        startHour.setMilliseconds(0);
        endHour.setMilliseconds(0);
        if (getDateInMs(date) < getDateInMs(startHour) || getDateInMs(date) >= getDateInMs(endHour) || !this.isWorkDay(date)) {
            return false;
        }
        return true;
    };
    ViewBase.prototype.getRenderDates = function () {
        this.renderDates = [];
        this.renderDates.push(resetTime(this.parent.selectedDate));
    };
    ViewBase.prototype.getNextPreviousDate = function (type) {
        if (type === 'next') {
            return addDays(this.parent.selectedDate, WEEK_LENGTH);
        }
        else {
            return addDays(this.parent.selectedDate, -WEEK_LENGTH);
        }
    };
    ViewBase.prototype.getLabelText = function (view) {
        return this.parent.localeObj.getConstant(view) + ' of ' +
            this.parent.globalize.formatDate(this.parent.selectedDate, { skeleton: 'long' });
    };
    ViewBase.prototype.getDateRangeText = function () {
        if (this.parent.isAdaptive) {
            return this.parent.globalize.formatDate(this.parent.selectedDate, { format: 'MMMM y' });
        }
        return this.formatDateRange(this.renderDates[0], this.renderDates[this.renderDates.length - 1]);
    };
    ViewBase.prototype.formatDateRange = function (startDate, endDate) {
        var globalize = this.parent.globalize;
        if (!isNullOrUndefined(this.parent.activeViewOptions.dateFormat)) {
            if (!endDate) {
                return globalize.formatDate(startDate, { format: this.parent.activeViewOptions.dateFormat });
            }
            return globalize.formatDate(startDate, { format: this.parent.activeViewOptions.dateFormat }) + ' - ' +
                globalize.formatDate(endDate, { format: this.parent.activeViewOptions.dateFormat });
        }
        var formattedStr;
        var longDateFormat;
        if (this.parent.locale === 'en' || this.parent.locale === 'en-US') {
            longDateFormat = getValue('dateFormats.long', getDefaultDateObject());
        }
        else {
            longDateFormat = getValue('main.' + '' + this.parent.locale + '.dates.calendars.gregorian.dateFormats.long', cldrData);
        }
        if (!endDate) {
            return globalize.formatDate(startDate, { format: longDateFormat });
        }
        var dateFormat = longDateFormat.trim().toLocaleLowerCase();
        if (dateFormat.substr(0, 1) === 'd') {
            if (startDate.getFullYear() === endDate.getFullYear()) {
                if (startDate.getMonth() === endDate.getMonth()) {
                    formattedStr = globalize.formatDate(startDate, { format: 'dd' }) + ' - ' +
                        globalize.formatDate(endDate, { format: 'dd MMMM yyyy' });
                }
                else {
                    formattedStr = globalize.formatDate(startDate, { format: 'dd MMM' }) + ' - ' +
                        globalize.formatDate(endDate, { format: 'dd MMM yyyy' });
                }
            }
            else {
                formattedStr = globalize.formatDate(startDate, { format: 'dd MMM yyyy' }) + ' - ' +
                    globalize.formatDate(endDate, { format: 'dd MMM yyyy' });
            }
        }
        else if (dateFormat.substr(0, 1) === 'm') {
            if (startDate.getFullYear() === endDate.getFullYear()) {
                if (startDate.getMonth() === endDate.getMonth()) {
                    formattedStr = globalize.formatDate(startDate, { format: 'MMMM dd' }) + ' - ' +
                        globalize.formatDate(endDate, { format: 'dd, yyyy' });
                }
                else {
                    formattedStr = globalize.formatDate(startDate, { format: 'MMM dd' }) + ' - ' +
                        globalize.formatDate(endDate, { format: 'MMM dd, yyyy' });
                }
            }
            else {
                formattedStr = globalize.formatDate(startDate, { format: 'MMM dd, yyyy' }) + ' - ' +
                    globalize.formatDate(endDate, { format: 'MMM dd, yyyy' });
            }
        }
        else {
            formattedStr = globalize.formatDate(startDate, { format: longDateFormat }) + ' - ' +
                globalize.formatDate(endDate, { format: longDateFormat });
        }
        return formattedStr;
    };
    ViewBase.prototype.getMobileDateElement = function (date, className) {
        var wrap = createElement('div', { className: className });
        var dateEle = createElement('div', { className: 'e-m-date' });
        dateEle.innerHTML = this.parent.globalize.formatDate(date, { format: 'd' });
        var dayEle = createElement('div', { className: 'e-m-day' });
        dayEle.innerHTML = this.parent.globalize.formatDate(date, { format: 'E' });
        wrap.appendChild(dateEle);
        wrap.appendChild(dayEle);
        return wrap;
    };
    return ViewBase;
}());
export { ViewBase };
